var map = {
	"./3-star-wish-reveal-first.mp3": 4271,
	"./3-star-wish-reveal.mp3": 6641,
	"./4-star-wish-reveal-first.mp3": 5891,
	"./4-star-wish-reveal.mp3": 6326,
	"./5-star-wish-reveal-first.mp3": 2922,
	"./5-star-wish-reveal.mp3": 599,
	"./banner-switch.mp3": 1518,
	"./bgm-wish.mp3": 9258,
	"./close-overlay.mp3": 8879,
	"./description-enter.mp3": 7412,
	"./description-exit.mp3": 7590,
	"./exit-dialog.mp3": 4290,
	"./item-obtain.mp3": 8430,
	"./quest-click.mp3": 4291,
	"./text-click.mp3": 3479,
	"./wish-button.mp3": 2933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7296;